/**
 * @generated SignedSource<<9574c515b3c242ffe7a1c3ee8e26a82d>>
 * @relayHash 0c3f5b6f132973196eb5dde485464ae7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a5a2f9034f6f2d43f02e7cbfd8367a1a7580bf07754d1effcb98118953235059

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessCalendarEmbedQuery } from './src_jiraBusinessCalendarEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessCalendarEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a5a2f9034f6f2d43f02e7cbfd8367a1a7580bf07754d1effcb98118953235059",
    "metadata": {},
    "name": "src_jiraBusinessCalendarEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
